/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { FormControl, Button, HelpBlock, Radio, Checkbox } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import ReactSelect, { Option } from 'react-select'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { updateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { HoldFunction, SpecialStatus, UpdateModeMethodId } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { SwitchButton, SwitchButtonWithTrigger } from '../../../../../../../generic'
import {
    createSupervisor,
    listUpdateModes,
    listBarrierTypes,
    listCriticalities,
    listSupervisors
} from '../../../../../../../services'
import {
    IBarrier,
    IUpdateMode,
    IBarrierType,
    ISupervisor,
    IMethod,
    IRelatedLink,
    IBarrierTypeIcon
} from '../../../../../../../types'
import { checkIsValidFrequencyRange, capitalize, isNullOrUndefined } from '../../../../../../../utils'
import { IEditorEscalation, IEditorBarrier, IUpdateMethodsOptions } from '../../../../BarrierEditor'
import { SelectCreatable, RedInfo } from '../../styles'
import { ContributionForm } from './components/ContributionForm'
import {
    FormField,
    UpdateMode,
    Escalations,
    RemoveEscalation,
    Manual,
    RelatedLinks,
    EvidencesSwitchButton,
    ManualInteractionWrapper
} from './style'

type IProps = {
    handleChange: () => void
    handleMethodChange: () => void
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
    item?: IBarrier[]
    handleGetRecursiveSearch?: (k: IEditorBarrier) => IEditorBarrier[]
    updateModeMethods: IUpdateMethodsOptions[]
    defaultMethod: IMethod
    barrierTypeIconMap: Map<number, IBarrierTypeIcon>
}

interface IBarrierTypeList extends IBarrierType {
    value: number
    label: string
}

type ISelectedDate = any

export const EditModal: React.FC<IProps> = ({
    item,
    handleChange,
    setLoading,
    handleGetRecursiveSearch,
    updateModeMethods,
    handleMethodChange,
    defaultMethod,
    barrierTypeIconMap
}) => {
    const [barrierTypeList, setBarrierTypeList] = useState<IBarrierTypeList[]>([])
    const [criticityList, setCriticityList] = useState<IBarrier['criticality'][]>([])
    const [supervisorList, setSupervisorList] = useState<ISupervisor[]>([])
    const [manualInteractionSwitchControl, setManualInteractionSwitchControl] = useState(false)
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const [switchEscalation, setSwitchEscalation] = useState<boolean>(item[0].escalations.length > 0)
    const [selectedDate, setSelectedDate] = useState<ISelectedDate>(moment())
    const [day, setDay] = useState<string>('')
    const [deadline, setDeadline] = useState<boolean>(false)
    const [isoDay, setIsoDay] = useState<string>()

    const handleAddNewLink = (): void => {
        const newLinksArray = item[0].evidences
        const linkToAdd: IRelatedLink = {
            alias: null,
            url: null
        }

        newLinksArray.push(linkToAdd)
        item.forEach(bar => {
            bar.evidences = [...newLinksArray]
        })

        handleChange()
    }

    const handleDeleteLink = (index: number): void => {
        const newLinksArray = item[0].evidences.splice(index, 1)
        handleChange()
    }

    const handleFormatIsoDate = (isoDate: string): number => {
        const receivedDate = new Date(isoDate)
        const formatedDate = receivedDate.setHours(23, 59, 59)

        return formatedDate
    }

    const handleValidateIsoDate = (isoDate: string, currentDate: string): boolean => {
        const isValidDate = moment(isoDate).isBefore(currentDate, 'hour')

        return isValidDate
    }

    const isQualitativeMethod = (): boolean => {
        const method = item[0]?.method?.method
        if (!method) return false

        return method === 'QUALITATIVE'
    }

    const divideBy = (value: string, divisor: number): string => {
        if (value === null || value === undefined || value === '') {
            return value
        }
        const newValue = parseFloat(value) / divisor
        if (isNaN(newValue)) {
            return ''
        }

        return String(newValue)
    }

    const multiplyBy = (value: string | number, multiplier: number): string | number => {
        if (value === null || value === undefined || value === '') {
            return value
        }
        if (typeof value === 'string') {
            const newValue = parseFloat(value) * multiplier
            if (isNaN(newValue)) {
                return ''
            }

            return String(newValue)
        }

        const newValue = ((value as unknown) as number) * multiplier

        return newValue
    }

    useEffect(() => {
        const handleFetches = async (): Promise<void> => {
            try {
                setLoading(true)
                await listCriticalities().then(e => setCriticityList(e.data))
                await listBarrierTypes().then(e =>
                    setBarrierTypeList(
                        e.data.map(el => {
                            const newObj: any = el
                            newObj.value = el.id
                            newObj.label = el.name

                            return newObj as IBarrierTypeList
                        })
                    )
                )
                await listSupervisors().then(e => setSupervisorList(e.data))
            } catch (e) {
                globalNotification.error(e.message && i18n('Error on fetching barrier data'))
            } finally {
                setLoading(false)
            }
        }
        handleFetches()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (item) {
            if (item[0].manualInteraction) setManualInteractionSwitchControl(true)
        }
    }, [item])

    useEffect(() => {
        if (item[0].escalations.length > 0) {
            setSwitchEscalation(true)
        }
    }, [item])

    if (!item) {
        return <></>
    }

    const handleGetUpdateModeConfiguration = (updateModeCode): JSX.Element => {
        const UpdateModeConfig = updateModeFrontAPI.getUpdateModeFrontPresenter(updateModeCode)?.component
        if (UpdateModeConfig) {
            return <UpdateModeConfig barrierPointers={item} onChanged={handleChange} editable={bowtieAdmin} />
        }
    }

    return (
        <>
            <FormField validationState={!item[0]?.name ? 'error' : 'success'}>
                <Label required className="control-label">
                    {i18n('Name')}
                </Label>
                <FormControl
                    readOnly={!bowtieAdmin}
                    type="text"
                    onChange={e => {
                        item.forEach(el => (el.name = (e.target as HTMLInputElement).value))
                        handleChange()
                    }}
                    id="barrierEditor-barrierEditModal-field-name"
                    value={item[0]?.name}
                    maxLength={255}
                    placeholder={`${i18n('new').toUpperCase()} ${i18n('BARRIER')}`}
                />
            </FormField>

            <FormField
                onKeyUp={e => {
                    const input = (e.target as HTMLDivElement).parentElement.parentElement.parentElement.parentElement
                        .getElementsByTagName('input')
                        ?.item(0)
                    const element = (e.target as HTMLDivElement).parentElement.parentElement.parentElement.parentElement
                        .getElementsByClassName('Select-menu-outer')
                        ?.item(0)

                    if (element && input) {
                        if (input.value?.length === 0) {
                            ;(element as HTMLDivElement).style.display = 'none'
                        } else if (element.hasAttribute('style')) {
                            ;(element as HTMLDivElement).removeAttribute('style')
                        }
                    }
                }}
                validationState={!item[0]?.supervisor?.name ? 'error' : 'success'}
                style={{ position: 'relative' }}
            >
                <Label required className="control-label">
                    {i18n('Responsible')}
                </Label>

                {bowtieAdmin ? (
                    <SelectCreatable
                        options={supervisorList.map(e => ({ value: e.id, label: e.name }))}
                        clearable={false}
                        onChange={(obj: Option<number>) => {
                            item.forEach(
                                el =>
                                    (el.supervisor = {
                                        id: obj.value,
                                        name: obj.label
                                    })
                            )

                            handleChange()
                        }}
                        id="barrierEditor-barrierEditModal-field-responsible"
                        onNewOptionClick={async (e: Option<number>) => {
                            try {
                                setLoading(true)

                                const newSupervisor = await createSupervisor({ name: e.label })
                                item.forEach(el => (el.supervisor = newSupervisor))
                                setSupervisorList([...supervisorList, newSupervisor])
                                handleChange()
                            } catch (err) {
                                globalNotification(err.message ?? i18n('An error occurred on register supervisor'))
                            } finally {
                                setLoading(false)
                            }
                        }}
                        promptTextCreator={e => `${i18n('Create new responsible:')} ${e}`}
                        value={{ value: item[0]?.supervisor?.id ?? null, label: item[0]?.supervisor?.name ?? null }}
                    />
                ) : (
                    <FormControl
                        readOnly
                        type="text"
                        id="barrierEditor-barrierEditModal-field-responsible_noedit"
                        value={item[0]?.supervisor.name}
                        maxLength={255}
                    />
                )}
            </FormField>
            <FormField validationState={!item[0]?.barrierType?.name ? 'error' : 'success'}>
                <Label required className="control-label">
                    {i18n('Barrier Category')}
                </Label>
                {bowtieAdmin ? (
                    <ReactSelect
                        options={barrierTypeList}
                        searchable={true}
                        clearable={false}
                        className="select-modal"
                        onChange={(obj: IBarrierTypeList) => {
                            item.forEach(el => {
                                if (obj.barrierTypeSpecial === SpecialStatus.UNMONITORED) {
                                    el.criticality = null
                                    el.manualInteraction = null
                                    el.updateModeCode = null
                                    el.updateModeJsonConfig = null
                                    el.escalations = []
                                }
                                const id = obj.barrierTypeIcon?.id
                                el.barrierType = {
                                    id: obj.value,
                                    name: obj.label,
                                    barrierTypeSpecial: obj.barrierTypeSpecial,
                                    author: obj.author,
                                    description: obj.description,
                                    deleteable: obj.deleteable,
                                    barrierTypeIcon:
                                        id !== null || id !== undefined ? barrierTypeIconMap.get(id) : null,
                                    updatedAt: obj.updatedAt
                                }
                            })

                            handleChange()
                        }}
                        value={{ value: item[0]?.barrierType?.id ?? null, label: item[0]?.barrierType?.name ?? null }}
                        id="barrierEditor-barrierEditModal-field-barrierType"
                    />
                ) : (
                    <FormControl
                        readOnly
                        type="text"
                        id="barrierEditor-barrierEditModal-field-barrierType_noedit"
                        value={item[0]?.barrierType.name}
                        maxLength={255}
                    />
                )}
            </FormField>
            {item[0]?.barrierType?.barrierTypeSpecial !== SpecialStatus.UNMONITORED && (
                <>
                    <FormField validationState={!item[0]?.criticality?.name ? 'error' : 'success'}>
                        <Label required className="control-label">
                            {i18n('Criticality')}
                        </Label>
                        {bowtieAdmin ? (
                            <ReactSelect
                                options={criticityList.map(e => ({ value: e.id, label: i18n(e.name) }))}
                                searchable={true}
                                clearable={false}
                                id="barrierEditor-barrierEditModal-field-criticality"
                                onChange={(obj: Option<number>) => {
                                    item.forEach(
                                        el =>
                                            (el.criticality = {
                                                id: obj.value,
                                                name: obj.label,
                                                level: criticityList.find(e => e.id === obj.value)?.level || 'HIGH'
                                            })
                                    )

                                    handleChange()
                                }}
                                value={{
                                    value: item[0]?.criticality?.id || undefined,
                                    label: item[0]?.criticality?.name || ''
                                }}
                            />
                        ) : (
                            <FormControl
                                readOnly
                                type="text"
                                id="barrierEditor-barrierEditModal-field-criticality_noedit"
                                value={item[0]?.criticality.name}
                                maxLength={255}
                            />
                        )}
                    </FormField>

                    <FormField>
                        <Label required className="control-label">
                            {i18n('Method')}
                        </Label>
                        <ReactSelect
                            options={updateModeMethods.map(method => {
                                return {
                                    value: method.id.toString(),
                                    label: i18n(capitalize(method.label)),
                                    id: method.id
                                }
                            })}
                            searchable={true}
                            clearable={false}
                            disabled={true}
                            id="barrierEditor-barrierEditModal-field-method"
                            onChange={(obj: IUpdateMethodsOptions) => {
                                if (item) {
                                    item.forEach(el => {
                                        el.method.id = Number(obj.value)
                                        el.method.method = obj.label
                                    })
                                    handleMethodChange()
                                }
                            }}
                            value={{
                                value: defaultMethod?.id.toString(),
                                label: i18n(capitalize(defaultMethod?.method ?? ''))
                            }}
                        />
                    </FormField>
                    {item[0]?.method && (
                        <FormField validationState={!item[0]?.updateModeCode ? 'error' : 'success'}>
                            <Label required className="control-label">
                                {i18n('Barrier Update Mode')}
                            </Label>
                            {bowtieAdmin ? (
                                <ReactSelect
                                    options={
                                        updateModeFrontAPI
                                            ?.getRepositoryKeysWithTitlesByMethod(item[0].method.method)
                                            .sort((a, b) => {
                                                const nameA = a.label.toUpperCase()
                                                const nameB = b.label.toUpperCase()
                                                if (nameA < nameB) {
                                                    return -1
                                                }
                                                if (nameA > nameB) {
                                                    return 1
                                                }

                                                return 0
                                            }) ?? []
                                    }
                                    searchable={true}
                                    clearable={false}
                                    id="barrierEditor-barrierEditModal-field-updateMode"
                                    // IupdateModeOption{
                                    // value:
                                    // label: string
                                    // defaultObj:IUpdateMode
                                    // }
                                    onChange={(obj: Option<string>) => {
                                        if (item) {
                                            item.forEach(el => {
                                                el.updateModeCode = obj.value
                                                el.updateModeJsonConfig = null
                                            })
                                            handleChange()
                                        }
                                    }}
                                    value={{
                                        value: item[0]?.updateModeCode || null,
                                        label: updateModeFrontAPI.getUpdateModeLabel(item[0]?.updateModeCode)
                                    }}
                                />
                            ) : (
                                <FormControl
                                    readOnly
                                    type="text"
                                    id="barrierEditor-barrierEditModal-field-updateMode_noedit"
                                    value={updateModeFrontAPI.getUpdateModeLabel(item[0]?.updateModeCode)}
                                    maxLength={255}
                                />
                            )}
                        </FormField>
                    )}

                    {item[0]?.updateModeCode && handleGetUpdateModeConfiguration(item[0].updateModeCode)}
                    <ManualInteractionWrapper>
                        <SwitchButton
                            id="manual-status-interaction"
                            label={i18n('Manual Barrier Status Interaction')}
                            onChange={newManualValue => {
                                if (newManualValue) {
                                    item.forEach(
                                        el =>
                                            (el.manualInteraction = {
                                                manualFinalPFD: null,
                                                manualInitialPFD: null,
                                                moc: null,
                                                responsiblePerson: null,
                                                manualQLR: null
                                            })
                                    )
                                } else {
                                    item.forEach(el => (el.manualInteraction = null))
                                }
                                handleChange()
                            }}
                            value={manualInteractionSwitchControl}
                            disabled={!bowtieAdmin}
                        />
                    </ManualInteractionWrapper>
                    {item[0].manualInteraction !== undefined && item[0].manualInteraction !== null && (
                        <>
                            <Manual>
                                {isQualitativeMethod() ? (
                                    <FormField
                                        validationState={
                                            !checkIsValidFrequencyRange(
                                                item[0].manualInteraction?.manualQLR,
                                                0,
                                                100,
                                                true,
                                                true
                                            )
                                                ? 'error'
                                                : 'success'
                                        }
                                    >
                                        <label className="control-label">
                                            {i18n('QLR')}
                                            {'*'}
                                        </label>
                                        <FormControl
                                            type="text"
                                            readOnly={!bowtieAdmin}
                                            onChange={e => {
                                                item.forEach(el => {
                                                    el.manualInteraction.manualQLR = divideBy(
                                                        (e.target as HTMLInputElement).value,
                                                        100
                                                    )
                                                })
                                                handleChange()
                                            }}
                                            value={multiplyBy(item[0]?.manualInteraction?.manualQLR, 100)}
                                            placeholder={i18n('QLR')}
                                        />

                                        <HelpBlock>{i18n('Value Between 0 and 100')}</HelpBlock>
                                    </FormField>
                                ) : (
                                    <>
                                        <FormField
                                            validationState={
                                                !checkIsValidFrequencyRange(item[0].manualInteraction?.manualInitialPFD)
                                                    ? 'error'
                                                    : 'success'
                                            }
                                        >
                                            <label className="control-label">{i18n('Initial PFD')}</label>
                                            <FormControl
                                                type="text"
                                                readOnly={!bowtieAdmin}
                                                onChange={e => {
                                                    item.forEach(el => {
                                                        el.manualInteraction.manualInitialPFD = (e.target as HTMLInputElement).value
                                                    })
                                                    handleChange()
                                                }}
                                                value={item[0]?.manualInteraction?.manualInitialPFD}
                                                placeholder={i18n('Initial PFD')}
                                            />

                                            <HelpBlock>{i18n('Value Between 0 and 1')}</HelpBlock>
                                        </FormField>
                                        <FormField
                                            validationState={
                                                !checkIsValidFrequencyRange(item[0].manualInteraction?.manualFinalPFD)
                                                    ? 'error'
                                                    : 'success'
                                            }
                                        >
                                            <label className="control-label">{i18n('Final PFD')}</label>
                                            <FormControl
                                                type="text"
                                                readOnly={!bowtieAdmin}
                                                onChange={e => {
                                                    item.forEach(el => {
                                                        el.manualInteraction.manualFinalPFD = (e.target as HTMLInputElement).value
                                                    })
                                                    handleChange()
                                                }}
                                                value={item[0]?.manualInteraction?.manualFinalPFD}
                                                placeholder={i18n('Final PFD')}
                                            />
                                            <HelpBlock>{i18n('Value Between 0 and 1')}</HelpBlock>
                                        </FormField>
                                    </>
                                )}

                                <FormField
                                    onKeyUp={e => {
                                        const input = (e.target as HTMLDivElement).parentElement.parentElement.parentElement.parentElement
                                            .getElementsByTagName('input')
                                            ?.item(0)
                                        const element = (e.target as HTMLDivElement).parentElement.parentElement.parentElement.parentElement
                                            .getElementsByClassName('Select-menu-outer')
                                            ?.item(0)

                                        if (element && input) {
                                            if (input.value?.length === 0) {
                                                ;(element as HTMLDivElement).style.display = 'none'
                                            } else if (element.hasAttribute('style')) {
                                                ;(element as HTMLDivElement).removeAttribute('style')
                                            }
                                        }
                                    }}
                                    validationState={
                                        !item[0]?.manualInteraction?.responsiblePerson ? 'error' : 'success'
                                    }
                                    style={{ position: 'relative' }}
                                >
                                    <Label required className="control-label">
                                        {i18n('Responsible')}
                                    </Label>

                                    {bowtieAdmin ? (
                                        <SelectCreatable
                                            options={supervisorList.map(e => ({ value: e.id, label: e.name }))}
                                            clearable={false}
                                            onChange={(obj: Option<any>) => {
                                                item.forEach(el => (el.manualInteraction.responsiblePerson = obj.label))

                                                handleChange()
                                            }}
                                            id="barrierEditor-barrierEditModal-field-manualInteraction-responsible"
                                            onNewOptionClick={async (e: Option<any>) => {
                                                try {
                                                    setLoading(true)

                                                    const newSupervisor = await createSupervisor({ name: e.label })
                                                    item.forEach(
                                                        el =>
                                                            (el.manualInteraction.responsiblePerson =
                                                                newSupervisor.name)
                                                    )
                                                    // const newSupervisorList = await listSupervisors()
                                                    // setSupervisorList(newSupervisorList.data)
                                                    setSupervisorList([...supervisorList, newSupervisor])
                                                    handleChange()
                                                } catch (err) {
                                                    globalNotification(
                                                        err.message ?? i18n('An error occurred on register supervisor')
                                                    )
                                                } finally {
                                                    setLoading(false)
                                                }
                                            }}
                                            promptTextCreator={e => `${i18n('Create new responsible:')} ${e}`}
                                            value={{
                                                value: null,
                                                label: item[0]?.manualInteraction?.responsiblePerson ?? null
                                            }}
                                        />
                                    ) : (
                                        <FormControl
                                            type="text"
                                            readOnly
                                            value={item[0]?.manualInteraction?.responsiblePerson}
                                            placeholder={i18n('Final PFD')}
                                        />
                                    )}
                                </FormField>
                                <FormField validationState={!item[0]?.manualInteraction?.moc ? 'error' : 'success'}>
                                    <label className="control-label">{i18n('Manifest Of Change (MOC)')}</label>
                                    <FormControl
                                        type="text"
                                        readOnly={!bowtieAdmin}
                                        onChange={e => {
                                            item.forEach(
                                                el => (el.manualInteraction.moc = (e.target as HTMLInputElement).value)
                                            )
                                            handleChange()
                                        }}
                                        value={item?.[0].manualInteraction?.moc}
                                        placeholder={i18n('MOC')}
                                    />
                                </FormField>

                                <FormField>
                                    <label className="control-label">
                                        <Checkbox
                                            checked={item[0].manualInteraction.expireAt != null}
                                            disabled={!bowtieAdmin}
                                            onChange={() => {
                                                if (item[0].manualInteraction.expireAt != null) {
                                                    item.forEach(
                                                        el =>
                                                            (el.manualInteraction = {
                                                                ...el.manualInteraction,
                                                                expireAt: null
                                                            })
                                                    )
                                                    setDeadline(false)
                                                    handleChange()
                                                } else {
                                                    item.forEach(
                                                        el =>
                                                            (el.manualInteraction = {
                                                                ...el.manualInteraction,
                                                                expireAt:
                                                                    handleFormatIsoDate(
                                                                        moment(selectedDate).toISOString()
                                                                    ) ?? new Date().getTime()
                                                            })
                                                    )
                                                    setDeadline(true)
                                                    handleChange()
                                                }
                                            }}
                                        >
                                            {i18n('Deadline')}
                                        </Checkbox>
                                    </label>
                                    <FormControl
                                        value={
                                            item[0].manualInteraction.expireAt
                                                ? moment(item[0].manualInteraction.expireAt).format('YYYY/MM/DD')
                                                : ''
                                        }
                                        type="text"
                                        placeholder={i18n('Choose date')}
                                    />
                                    {item[0].manualInteraction.expireAt != null && (
                                        <DatePicker
                                            inline
                                            selected={
                                                item[0].manualInteraction.expireAt != null
                                                    ? moment(item[0].manualInteraction.expireAt)
                                                    : selectedDate
                                            }
                                            minDate={new Date()}
                                            onChange={date => {
                                                setSelectedDate(moment(date as Date))
                                                setDay(moment(date as Date).format('YYYY/MM/DD'))
                                                setIsoDay(moment(date as Date).toISOString())

                                                if (
                                                    handleValidateIsoDate(
                                                        moment(date as Date).toISOString(),
                                                        new Date().toUTCString()
                                                    )
                                                ) {
                                                    globalNotification.error(i18n('Please insert a valid date'))
                                                } else {
                                                    item.forEach(
                                                        el =>
                                                            (el.manualInteraction.expireAt = handleFormatIsoDate(
                                                                moment(date as Date).toISOString()
                                                            ))
                                                    )
                                                    handleChange()
                                                }
                                            }}
                                        />
                                    )}
                                </FormField>
                            </Manual>
                            <RedInfo>*{i18n('Manual barrier is on indefinitely unless deadline is set.')}</RedInfo>
                        </>
                    )}
                </>
            )}
            <RelatedLinks>
                <EvidencesSwitchButton
                    id="external-related-links"
                    label={i18n('External Related Links')}
                    disabled={!bowtieAdmin}
                    onChange={newRelatedLinksValue => {
                        if (newRelatedLinksValue) {
                            item.forEach(
                                el =>
                                    (el.evidences = [
                                        {
                                            alias: '',
                                            url: ''
                                        }
                                    ])
                            )
                        } else {
                            item.forEach(el => (el.evidences = null))
                        }
                        handleChange()
                    }}
                    value={item[0].evidences != null && item?.at(0)?.evidences?.length > 0}
                />
                {item[0].evidences != null && item?.at(0)?.evidences?.length > 0 && (
                    <>
                        {item[0].evidences.map((link, index) => {
                            return (
                                <div key={index} className="link-set">
                                    <FormField>
                                        <Label className="control-label">{i18n('Label')}</Label>
                                        <FormControl
                                            type="text"
                                            componentClass="textarea"
                                            readOnly={!bowtieAdmin}
                                            onChange={e => {
                                                item.forEach(
                                                    el =>
                                                        (el.evidences[
                                                            index
                                                        ].alias = (e.target as HTMLInputElement).value)
                                                )
                                                handleChange()
                                            }}
                                            value={link.alias}
                                            maxLength={40}
                                        />
                                    </FormField>
                                    <FormField>
                                        <Label className="control-label">{i18n('URL Link')}</Label>
                                        <FormControl
                                            type="text"
                                            readOnly={!bowtieAdmin}
                                            componentClass="textarea"
                                            className="url-textarea"
                                            onChange={e => {
                                                item.forEach(
                                                    el =>
                                                        (el.evidences[index].url = (e.target as HTMLInputElement).value)
                                                )
                                                handleChange()
                                            }}
                                            value={link.url}
                                        />
                                    </FormField>
                                    <div className="link-icon">
                                        {bowtieAdmin && (
                                            <i
                                                key={index}
                                                className="far fa-trash-alt"
                                                onClick={() => handleDeleteLink(index)}
                                            ></i>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                        <Button
                            disabled={!bowtieAdmin}
                            className="new-link-button"
                            bsStyle="primary"
                            onClick={() => {
                                handleAddNewLink()
                            }}
                        >
                            <i className="fas fa-plus"></i> {i18n('Add Link')}
                        </Button>
                    </>
                )}
            </RelatedLinks>
        </>
    )
}
